import { match } from 'ts-pattern';

import type { SubscriptionMe } from '@/entities/subscription';

// Four situations across three provider statuses: an ACTIVE plan reads differently once a
// cancellation is scheduled. Trials map to nothing — there is no billing to summarise until a
// plan is chosen, so the page offers the picker instead of the card.
export type BillingStatus = 'active' | 'cancelling' | 'canceled' | 'past-due';

export const getBillingStatus = (
    subscription: Pick<SubscriptionMe, 'status' | 'cancelAtPeriodEnd' | 'isTrial'>,
): BillingStatus | null =>
    match(subscription)
        .with({ status: 'ACTIVE', cancelAtPeriodEnd: true }, () => 'cancelling' as const)
        .with({ status: 'ACTIVE' }, () => 'active' as const)
        .with({ status: 'PAST_DUE' }, () => 'past-due' as const)
        .with({ status: 'CANCELED', isTrial: false }, () => 'canceled' as const)
        .with({ status: 'CANCELED' }, () => null)
        .with({ status: 'TRIALING' }, () => null)
        .exhaustive();
